"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FilePurposes;
(function (FilePurposes) {
    FilePurposes.profileImage = 'profileImage';
    FilePurposes.menuBackgroundImage = 'menuBackgroundImage';
    FilePurposes.announcementAttachment = 'announcementAttachment';
    FilePurposes.logoIcon = 'logoIcon';
    FilePurposes.memoBannerImage = 'memoBannerImage';
    FilePurposes.memoriamVideo = 'memoriamVideo';
    FilePurposes.videoThumbnail = 'videoThumbnail';
    FilePurposes.transcodedMp4 = 'transcodedMp4';
    FilePurposes.transcodedHls = 'transcodedHls';
    FilePurposes.dataExport = 'dataExport';
    FilePurposes.sizeTiny = 'sizeTiny';
    FilePurposes.sizeMedium = 'sizeMedium';
    FilePurposes.sizeLarge = 'sizeLarge';
})(FilePurposes = exports.FilePurposes || (exports.FilePurposes = {}));
